import computeClassName from '../../../../../../../utils/computeClassName';
import ResultTabs from './ResultTabs';
import TabbedResults from './TabbedResults';

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function SearchResults({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  return (
    <section className={computedClassName}>
      <ResultTabs className="__MR_HOME_SEARCH_MAIN_RESULT-TABS__ -mx-4"/>
      <TabbedResults className="__MR_HOME_SEARCH_MAIN_RESULTS__ flex-grow flex flex-col justify-center"/>
    </section>
  );

}
